import { render, staticRenderFns } from "./BrankasErrorPageComponent.vue?vue&type=template&id=39333123&"
import script from "./BrankasErrorPageComponent.vue?vue&type=script&lang=js&"
export * from "./BrankasErrorPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports